<template>
  <slot v-if="isChecked && !isBlocked" />
  <div v-else-if="isBlocked" class="auth">
    <div class="auth-wrapper">
      <v-empty-state
        icon="mdi-tab-unselected"
        title="This application is already open in another tab"
        text="Please close the other tab or continue there, then try again."
      >
        <template #actions>
          <v-btn color="primary" @click="acquire">Try again</v-btn>
        </template>
      </v-empty-state>
    </div>
  </div>
</template>
<script>
// The lock is held by the tab until it is closed or navigated away (Web Locks API),
// so the same form (route name + application id) can not be opened in two tabs at once.
// Different forms (short / full / agent) with the same id are allowed.
export default {
  name: 'FormTabGuard',
  data() {
    return {
      isChecked: false,
      isBlocked: false,
      releaseLock: null,
      attempt: 0
    };
  },
  computed: {
    applicationId() {
      return this.$route?.params?.id;
    },
    lockName() {
      return `xtrapension-${String(this.$route?.name)}-${this.applicationId}`;
    }
  },
  watch: {
    lockName() {
      this.acquire();
    }
  },
  mounted() {
    this.acquire();
  },
  beforeUnmount() {
    this.attempt++;
    this.release();
  },
  methods: {
    release() {
      if (this.releaseLock) {
        this.releaseLock();
        this.releaseLock = null;
      }
    },
    async acquire() {
      const attempt = ++this.attempt;
      this.release();
      if (!navigator.locks || !this.applicationId) {
        this.isBlocked = false;
        this.isChecked = true;
        return;
      }
      let release = null;
      const tryLock = () =>
        new Promise((resolveAcquired) => {
          navigator.locks.request(this.lockName, { ifAvailable: true }, (lock) => {
            if (!lock) {
              resolveAcquired(false);
              return undefined;
            }
            return new Promise((resolveHeld) => {
              release = resolveHeld;
              resolveAcquired(true);
            });
          });
        });
      const isAcquired = await tryLock();
      // Superseded by a newer attempt or the component was unmounted
      if (attempt !== this.attempt) {
        if (release) release();
        return;
      }
      this.releaseLock = release;
      this.isBlocked = !isAcquired;
      this.isChecked = true;
    }
  }
};
</script>
